import React, { useState } from 'react';
import {
    DateInput,
    Create,
    SelectInput,
    TextInput,
    SimpleForm,
    required,
    choices,
    useNotify,
    useRedirect,
    SaveButton,
    Toolbar
} from 'react-admin';

import {
    Container,
    Paper,
    Typography,
    Grid,
    Box,
    Button,
    Alert,
    Snackbar
} from '@mui/material';

import PersonIcon from '@mui/icons-material/Person';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';

import allStates from '../donors/AllStates';
import SanitizedTextInput from '../controls/SanitizedTextInput';
import ErrorBoundary from '../ErrorBoundary';
import jwt_decode from 'jwt-decode';
import Sign from '../controls/SignatureKiosk'

const location = localStorage?.token ? jwt_decode(localStorage.token)?.location || '' : '';
const branch_code = localStorage?.token ? jwt_decode(localStorage.token)?.branch_code || '' : '';
const setDonSignatureValue=(image)=>{
    donorSing = image;
}

const genderValues = [
    { id: 'Male', name: 'Male' },
    { id: 'Female', name: 'Female' },
    { id: 'Other', name: 'Other' }
];

const YesNo = [
    { id: 'Yes', name: 'Yes' },
    { id: 'No', name: 'No' }
];

const validateGender = choices(['Male', 'Female', 'Other'], 'Must be Male, Female or Other');

const inputStyle = {
    bgcolor: 'white',
    borderRadius: 2,
    border: '1px solid rgba(40, 53, 147, 0.35)',
    py: 1.5,
    px: 2,
    fontSize: 16,
    boxShadow: '0 1px 3px rgba(16, 24, 64, 0.08)'
};

const sectionStyle = {
    mb: 4,
    p: 4,
    bgcolor: '#f4f6fb',
    border: '1px solid rgba(40, 53, 147, 0.08)',
    borderRadius: 3,
    boxShadow: '0 2px 10px rgba(16, 24, 64, 0.06)'
};

const buttonStyle = {
    fontSize: 18,
    py: 1,
    px: 4,
    borderRadius: 2,
    boxShadow: 3,
    fontWeight: 'bold'
};

var donorSing = null;

const CreateToolbar = props => (
    <Toolbar {...props} sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
    <Grid container justifyContent="center">
        <Grid item>
            <SaveButton
                {...props}
                label="✅ Save & Complete"
                redirect="/"
                transform={data => ({ ...data, donor_sign: donorSing })}
                submitOnEnter={true}
                sx={{
                    fontSize: 22,       // Large font
                    px: 6,              // Horizontal padding
                    py: 2,              // Vertical padding
                    borderRadius: 3,    // Rounded edges
                    bgcolor: 'primary.main',  // Primary color
                    color: 'white',     // White text
                    boxShadow: 4,       // Adds depth
                    width: 'auto',      // Auto width based on content
                    minWidth: '280px',  // Ensures enough space for text
                    height: '50px',     // Taller button for better touch interaction
                    whiteSpace: 'nowrap',  // ❌ Prevents text from wrapping
                    textAlign: 'center', // Centers the text
                    display: 'inline-flex', // Ensures proper button rendering
                    justifyContent: 'center', // Centers text inside the button
                    alignItems: 'center', // Centers vertically
                    mb: 4 // ✅ Adds bottom margin
                }}
                style={{
                    fontSize: '22px', // Force font size
                    padding: '20px 40px', // Force padding
                    width: '320px', // Force enough width
                    height: '60px', // Force enough height
                    backgroundColor: '#283593', // Primary color
                    color: 'white', // White text
                    borderRadius: '12px', // Rounded corners
                    boxShadow: '0px 4px 10px rgba(0,0,0,0.2)', // Extra shadow
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    whiteSpace: 'nowrap', // Force single-line text
                    textTransform: 'none', // Prevents automatic uppercase
                    marginBottom: '30px', // ✅ Adds bottom margin
                }}
                ButtonProps={{
                    sx: {
                        transition: 'all 0.3s ease-in-out', // ✅ Smooth hover effect
                        '&:hover': { 
                            bgcolor: 'primary.dark', // ✅ Correctly applies hover background
                            transform: 'scale(1.05)', // ✅ Slight zoom effect on hover
                            boxShadow: '0px 6px 12px rgba(0,0,0,0.3)' // ✅ Stronger hover shadow
                        }
                    }
                }}
            />
        </Grid>
    </Grid>
</Toolbar>
);
const NewDonor = (props) => {
    const [message, setMessage] = useState(null);
    const [notifyMessage, setNotifyMessage] = useState(null);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const notify = useNotify();
    const redirect = useRedirect();

    const handleSuccess = () => {
        setNotifyMessage({ type: "success", text: "✅ Registration successful! Please proceed to the front desk." });
        setOpenSnackbar(true);
        setTimeout(() => redirect('/'), 3000); // Redirect after showing the message
    };

    const handleFailure = () => {
        setNotifyMessage({ type: "error", text: "❌ Registration failed. Please contact the front desk." });
        setOpenSnackbar(true);
    };

    return (
        <ErrorBoundary>
            <Create {...props} title="New Donor" onSuccess={handleSuccess} onFailure={handleFailure}>
                <SimpleForm toolbar={<CreateToolbar />} >
                    <Container maxWidth="md">
                        <Paper elevation={6} sx={{ p: 5, borderRadius: 4 }}>
                            <Typography variant="h4" sx={{ textAlign: 'center', mb: 3, fontWeight: 'bold', color: '#283593' }}>
                                🩸 Donor Registration Kiosk
                            </Typography>
                             {/* ✅ Full-width Snackbar Notification */}
                            <Snackbar
                                open={openSnackbar}
                                autoHideDuration={5000}
                                onClose={() => setOpenSnackbar(false)}
                                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                            >
                                <Alert severity={notifyMessage?.type} sx={{
                                    fontSize: 24, 
                                    p: 2, 
                                    width: '100%', 
                                    textAlign: 'center', 
                                    bgcolor: notifyMessage?.type === "success" ? "#4caf50" : "#d32f2f", 
                                    color: "white",
                                    borderRadius: 2
                                }}>
                                    {notifyMessage?.text}
                                </Alert>
                            </Snackbar>
                            <Typography variant="h6" sx={{ textAlign: 'center', mb: 2, color: 'grey.700' }}> 
                                📍 Location: {location}
                            </Typography>

                            {message && (

                                <Alert severity={message.type} sx={{ mb: 3, fontSize: 18, borderRadius: 2 }}>
                                    {message.text}
                                </Alert>
                            )}

                            <Box sx={sectionStyle}>
                                <Typography variant="h5" sx={{ mb: 2, display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
                                    <PersonIcon sx={{ fontSize: 30, mr: 1, color: '#283593' }} /> Personal Information
                                </Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={4}><SanitizedTextInput source="f_name" label="First Name" validate={required()} fullWidth sx={inputStyle} /></Grid>
                                    <Grid item xs={12} md={4}><SanitizedTextInput source="m_name" label="Middle Initial" fullWidth sx={inputStyle} /></Grid>
                                    <Grid item xs={12} md={4}><SanitizedTextInput source="l_name" label="Last Name" validate={required()} fullWidth sx={inputStyle} /></Grid>
                                    <Grid item xs={12} md={4}><SanitizedTextInput source="street" label="Street" validate={required()} fullWidth sx={inputStyle} /></Grid>
                                    <Grid item xs={12} md={4}><SanitizedTextInput source="city" label="City" validate={required()} fullWidth sx={inputStyle} /></Grid>
                                    <Grid item xs={12} md={4}><SanitizedTextInput source="zip" label="Zip" validate={required()} fullWidth sx={inputStyle} inputProps={{ maxLength: 5, pattern: '[0-9]*' }} /></Grid>
                                    <Grid item xs={12} md={4}><SelectInput source="state" label="State" validate={required()} choices={allStates} fullWidth sx={inputStyle} /></Grid>
                                    <Grid item xs={12} md={4}><SelectInput source="gender" label="Gender" choices={genderValues} validate={[required(), validateGender]} fullWidth sx={inputStyle} /></Grid>
                                    <Grid item xs={12} md={4}><SanitizedTextInput source="don_ph" label="Phone" validate={required()} fullWidth sx={inputStyle} /></Grid>
                                    <Grid item xs={12} md={6}><SanitizedTextInput source="email" label="Email" validate={required()} fullWidth sx={inputStyle} /></Grid>
                                    <Grid item xs={12} md={6}><SanitizedTextInput source="about_us" label="How did you hear about us?" validate={required()} fullWidth sx={inputStyle} /></Grid>
                                    
                                </Grid>
                            </Box>

                            <Box sx={sectionStyle}>
                                <Typography variant="h5" sx={{ mb: 2, display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
                                    <LocalHospitalIcon sx={{ fontSize: 30, mr: 1, color: 'red' }} /> Medical History
                                </Typography>
                                <Grid container spacing={2}>
                                    
                                    <Grid item xs={12} md={6}>
                                        <span fullWidth style={{padding: 2, fontSize: 12, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}} >HAVE YOU EVER HAD ANY SURGERY? </span>
                                        <SelectInput choices={YesNo} source="surgery" label="" fullWidth sx={inputStyle} />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <span fullWidth style={{padding: 2, fontSize: 14, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}}>Date of last Surgery </span>
                                        <DateInput source="sergery_date" label="" fullWidth sx={inputStyle} />
                                    </Grid>
                                    
                                    <Grid item xs={12} md={6}>
                                        <span fullWidth style={{padding: 2, fontSize: 12, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}} >HAVE YOU HAD ANY EAR OR BODY    PIERCINGS, TATTOO OR ANY TATTOO TOUCH-UPS IN THE PAST 12 MONTHS?</span>
                                        <SelectInput choices={YesNo} source="tattoo_12" label="" fullWidth sx={inputStyle} />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <span fullWidth style={{padding: 2, fontSize: 14, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}}>Date of Last Piercing/Tattoo/Touch-Up</span>
                                        <DateInput source="tattoo_12_date" label="" fullWidth sx={inputStyle} locales="en-us"/>
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <span fullWidth style={{padding: 2, fontSize: 12, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}} >DID YOU EAT SOMETHING WITHIN THE LAST 4 HOURS?</span>
                                        <SelectInput choices={YesNo} source="eat_4" label="" fullWidth sx={inputStyle} />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <span fullWidth style={{padding: 2, fontSize: 14, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}}>What</span>
                                        <SanitizedTextInput source="eat_what" label="" fullWidth sx={inputStyle} locales="en-us"/>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <span fullWidth style={{padding: 2, fontSize: 12, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}} >IF FEMALE:  HAVE YOU BEEN PREGNANT WITHIN THE PAST 12 MONTHS?</span>
                                        <SelectInput choices={YesNo} source="pregnant_12" label="" fullWidth sx={inputStyle} />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <span fullWidth style={{padding: 2, fontSize: 14, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}}>Date of Last Pregnancy</span>
                                        <DateInput source="pregnant_date" label="" fullWidth sx={inputStyle} locales="en-us"/>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <span fullWidth style={{padding: 2, fontSize: 12, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}}>HAVE YOU DONATED PLASMA OR BLOOD IN THE PAST?</span>
                                        <SelectInput choices={YesNo} source="donated_plasma" label="" fullWidth sx={inputStyle} />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <span fullWidth style={{padding: 2, fontSize: 14, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}}>When</span>
                                        <DateInput source="donated_date" label="" fullWidth sx={inputStyle} locales="en-us"/>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <span fullWidth style={{padding: 2, fontSize: 12, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}}>DO YOU HAVE A PROSTHETIC LIMB?</span>
                                        <SelectInput choices={YesNo} source="limb" label="" fullWidth sx={inputStyle} />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <span fullWidth style={{padding: 2, fontSize: 14, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}}>Body Part</span>
                                        <SanitizedTextInput source="body_part" label="" fullWidth sx={inputStyle} locales="en-us"/>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <span fullWidth style={{padding: 2, fontSize: 12, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}}>HAVE YOU BEEN IN JAIL OR PRISON DURING THE LAST 12 MONTHS FOR A PERIOD GREATER THAN 72 HOURS?</span>
                                        <SelectInput choices={YesNo} source="jail_72" label="" fullWidth sx={inputStyle} />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <span fullWidth style={{padding: 2, fontSize: 14, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}}>Date of release</span>
                                        <DateInput source="jail_72_date" label="" fullWidth sx={inputStyle} locales="en-us"/>
                                        <TextInput id="branch_code" source='branch_code'  defaultValue={branch_code} style={{display:'none'}}  />
                                        <TextInput id="location" source='location'  defaultValue={location} style={{display:'none'}}  />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <span fullWidth style={{padding: 2, fontSize: 12, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}} >DO YOU TAKE ANY MEDICATIONS? </span>
                                        <SelectInput choices={YesNo} source="medications" label="" fullWidth sx={inputStyle} />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <span fullWidth style={{padding: 2, fontSize: 14, fontFamily: 'arial', height: '25px',minHeight: '25px', display: 'flex'}}>List of Medications  </span>
                                        <SanitizedTextInput source="medications_list" label="" multiline={true} minRows={3} maxRows={6} fullWidth sx={inputStyle} />
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box sx={{ p: 3, borderRadius: 3, bgcolor: '#f5f5f5', boxShadow: 3 }}>
                            <Grid container spacing={3} alignItems="center">
                                
                                {/* Donor Signature Label */}
                                <Grid item xs={12} md={4}>
                                    <Box sx={{ fontSize: 24, fontWeight: 'bold', textAlign: 'left' }}>
                                        🖊️ DONOR SIGNATURE:
                                    </Box>
                                </Grid>

                                {/* Signature Input */}
                                <Grid item xs={12} md={4}>
                                    <Box
                                        sx={{
                                            border: '2px solid #283593',
                                            borderRadius: 2,
                                            p: 2,
                                            minHeight: 120, // ✅ Large touch-friendly signing area
                                            bgcolor: '#fff',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <Sign setSignatureValue={setDonSignatureValue} />
                                    </Box>
                                </Grid>

                                {/* Date Input */}
                                <Grid item xs={12} md={4}>
                                    <DateInput 
                                        source="sign_date" 
                                        label="📅 DATE"  
                                        locales="en-us"
                                        sx={{
                                            fontSize: 24, 
                                            p: 2, 
                                            width: '100%',
                                            borderRadius: 2,
                                            bgcolor: '#fff'
                                        }} 
                                    />
                                </Grid>

                            </Grid>
                        </Box>
                        </Paper>
                    </Container>
                </SimpleForm>
            </Create>
        </ErrorBoundary>
    );
};

export default NewDonor; 

